import apps from './apps/apps.module.js';
import auth from './auth/auth.module.js';
import retentionTrends from './retention-trends/retention-trends.module.js';
import adoptionTrends from './adoption-trends/adoption-trends.module.js';
import trendsSettings from './trends/trends-settings.module.js';
import pendoCollaboration from './pendo-collaboration/pendo-collaboration.module.js';
import coreEvents from './core-events/core-events.module.js';
import dashboards from './dashboards/dashboards.module.js';
import devicesConnection from './devices-connection/devices-connection.module.js';
import domains from './domains/domains.module.js';
import emails from './emails/emails.module.js';
import essentialContacts from './essential-contacts/essential-contacts.module.js';
import experiments from './experiments/experiments.module.js';
import features from './features/features.module.js';
import feedbackLinking from './feedback-linking/feedback-linking.module.js';
import permissionGroups from './feedback-linking/permission-groups/permission-groups.module.js';
import products from './feedback-linking/products/products.module.js';
import signingKeys from './feedback-linking/signing-keys/signing-keys.module.js';
import vendorUsers from './feedback-linking/vendor-users/vendor-users.module.js';
import vendors from './feedback-linking/vendors/vendors.module.js';
import feedbackProducts from './feedback-products/feedback-products.module.js';
import feedbackRequests from './feedback-requests/feedback-requests.module.js';
import feedbackSettings from './feedback-settings/feedback-settings.module.js';
import feedbackStatuses from './feedback-statuses/feedback-statuses.module.js';
import globalFilters from './global-filters/global-filters.module.js';
import groups from './groups/groups.module.js';
import guideCategories from './guide-categories/guide-categories.module.js';
import guides from './guides/guides.module.js';
import nps from './guides/nps/nps.module.js';
import resourceCenter from './guides/resource-center/resource-center.module.js';
import insights from './insights/insights.module.js';
import integrationKeys from './integrations/integration-keys/integration-keys.module.js';
import integrations from './integrations/integrations.module.js';
import integrationJira from './integrations/jira/jira.module.js';
import metadataProviders from './integrations/metadata-providers/metadata-providers.module.js';
import salesforce from './integrations/salesforce/salesforce.module.js';
import serviceAccounts from './integrations/service-accounts/service-accounts.module.js';
import webhooks from './integrations/webhooks/webhooks.module.js';
import itemGroups from './item-groups/item-groups.module.js';
import graph from './journeys/graph/graph.module.js';
import journeys from './journeys/journeys.module.js';
import labels from './labels/labels.module.js';
import layouts from './layouts/layouts.module.js';
import metaGroups from './meta-groups/meta-groups.module.js';
import metadata from './metadata/metadata.module.js';
import pages from './pages/pages.module.js';
import suggestedPages from './pages/suggested-pages/suggested-pages.module.js';
import productLines from './product-lines/product-lines.module.js';
import columns from './roadmaps/columns/columns.module.js';
import items from './roadmaps/items/items.module.js';
import modals from './roadmaps/modals/modals.module.js';
import roadmaps from './roadmaps/roadmaps-module/roadmaps.module.js';
import swimlanes from './roadmaps/swimlanes/swimlanes.module.js';
import savedFilters from './saved-filters/saved-filters.module.js';
import funnels from './saved-reports/funnels.module.js';
import paths from './saved-reports/paths.module.js';
import savedReports from './saved-reports/saved-reports.module.js';
import savedViews from './saved-views/saved-views.module.js';
import segments from './segments/segments.module.js';
import smartSegments from './smart-segments/smart-segments.module.js';
import subscription from './subscription/subscription.module.js';
import superSubscription from './subscription/super/super.module.js';
import teams from './teams/teams.module.js';
import themes from './themes/themes.module.js';
import trackTypes from './track-types/track-types.module.js';
import userJourney from './user-journey/user-journey.module.js';
import history from './user-settings/history/history.module.js';
import userSettings from './user-settings/user-settings.module.js';
import users from './users/users.module.js';
import filters from './voc-items/filters/filters.module.js';
import vocJira from './voc-items/jira/jira.module.js';
import vocRoadmaps from './voc-items/roadmaps/roadmaps.module.js';
import sources from './voc-items/sources/sources.module.js';
import vocTable from './voc-items/table/table.module.js';
import vocItems from './voc-items/voc-items.module.js';
import vocPollWizard from './voc-poll-wizard/voc-poll-wizard.module.js';
import vocLabels from './voc/labels/labels.module.js';
import vocModals from './voc/modals/modals.module.js';
import vocOnboarding from './voc/onboarding/onboarding.module.js';
import workflows from './workflows/workflows.module.js';

export default {
    insights,
    savedFilters,
    productLines,
    pendoCollaboration,
    feedbackProducts,
    roadmaps: {
        namespaced: true,
        modules: {
            roadmaps,
            swimlanes,
            modals,
            columns,
            items,
        },
    },
    domains,
    userSettings: {
        ...userSettings,
        modules: {
            history,
        },
    },
    vocItems: {
        ...vocItems,
        modules: {
            filters,
            roadmaps: vocRoadmaps,
            jira: vocJira,
            table: vocTable,
            sources,
        },
    },
    savedViews,
    feedbackSettings,
    auth,
    itemGroups,
    experiments,
    trackTypes,
    emails,
    features,
    labels,
    workflows,
    retentionTrends,
    adoptionTrends,
    trendsSettings,
    groups,
    devicesConnection,
    coreEvents,
    userJourney,
    subscription: {
        ...subscription,
        modules: {
            super: superSubscription,
        },
    },
    integrations: {
        ...integrations,
        modules: {
            metadataProviders,
            jira: integrationJira,
            integrationKeys,
            salesforce,
            serviceAccounts,
            webhooks,
        },
    },
    globalFilters,
    voc: {
        namespaced: true,
        modules: {
            labels: vocLabels,
            modals: vocModals,
            onboarding: vocOnboarding,
        },
    },
    layouts,
    dashboards,
    guides: {
        ...guides,
        modules: {
            nps,
            resourceCenter,
        },
    },
    users,
    feedbackRequests,
    teams,
    feedbackLinking: {
        ...feedbackLinking,
        modules: {
            vendors,
            products,
            permissionGroups,
            signingKeys,
            vendorUsers,
        },
    },
    guideCategories,
    journeys: {
        ...journeys,
        modules: {
            graph,
        },
    },
    metaGroups,
    essentialContacts,
    feedbackStatuses,
    pages: {
        ...pages,
        modules: {
            suggestedPages,
        },
    },
    apps,
    themes,
    metadata,
    smartSegments,
    vocPollWizard,
    segments,
    savedReports: {
        ...savedReports,
        modules: {
            paths,
            funnels,
        },
    },
};
